import { render, staticRenderFns } from "./HeroDetails.vue?vue&type=template&id=12a49d08&scoped=true"
import script from "./HeroDetails.vue?vue&type=script&lang=js"
export * from "./HeroDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a49d08",
  null
  
)

export default component.exports